import { authApiCall } from "../../../auth";

export const updateUserMembership = (user_id, user_type, membership) => {
  return authApiCall({
    url: `/users/admin/update-membership/${user_id}/`,
    method: 'patch',
    data: {user_type, membership}
  });
};
